export default __webpack_public_path__ + "static/media/user-profile.19c24032.webp";